import { useContext } from 'react'

import { useNavigate } from 'react-router-dom'
import { useTenant, useToast, useToggle } from 'shared/hooks'
import { joiResolver } from '@hookform/resolvers/joi'
import { useForm } from 'react-hook-form'

import { LoginRequest, usePostLogon } from 'services/auth'
import { handleSetCookies } from 'services/auth/utilities/auth'
import { loginSchema } from 'domains/auth/screens/Login/schemas'
import { UserContext } from 'shared/contexts/user/user'

import { Button, Modal } from 'components'
import { TextField } from 'uikit'

import { ResetPassword, Loader } from './components'
import styles from './styles.module.scss'

const Form = () => {
  const navigate = useNavigate()
  const { tenant } = useTenant()
  const { addToast } = useToast()

  const { setUser, fetchUserAccounts } = useContext(UserContext)

  const { mutate, isLoading } = usePostLogon()

  const {
    register,
    handleSubmit,
    formState: { errors, isDirty },
  } = useForm<LoginRequest>({
    mode: 'onSubmit',
    resolver: joiResolver(loginSchema),
  })

  const handleOnSubmit = (formData: LoginRequest) => {
    mutate(formData, {
      onSuccess: (data) => {
        handleSetCookies({
          userId: data.id,
          name: data.name,
          email: formData.login,
          profileImageURL: data.profileImageURL || '',
          accessToken: data.accessToken,
          refreshToken: data.refreshToken,
        })

        localStorage.setItem('accountId', data.defaultAccountId || '')

        setUser({
          profileImageURL: data.profileImageURL || '',
          defaultAccountId: data.defaultAccountId || '',
          email: formData.login || '',
          name: data.name,
        })

        navigate('/')

        fetchUserAccounts()
      },
      onError: (error) => {
        if (error?.response?.status === 401) {
          addToast({
            message:
              'E-mail ou senha inválidos. Tente novamente ou clique em "Esqueci minha senha"',
            type: 'alert',
          })

          return
        }

        addToast({
          message: 'Erro ao tentar fazer login. Tente novamente.',
          type: 'alert',
        })
      },
    })
  }

  return (
    <div className={styles.formContainer}>
      {isLoading && <Loader />}

      <form onSubmit={handleSubmit(handleOnSubmit)}>
        <div className={styles.wrapper}>
          <div>
            <h1>{tenant?.ubiportal.loginPage.text}</h1>
            <h2>{tenant?.ubiportal.loginPage.greetingText}</h2>
          </div>

          <div className={styles.fields}>
            <TextField
              label="Email"
              {...register('login')}
              spellCheck="false"
              message={errors?.login?.message}
              appearance={errors?.login ? 'error' : 'neutral'}
            />

            <TextField
              label="Senha"
              type="password"
              {...register('password')}
            />
          </div>

          <div className={styles.footer}>
            <Button disabled={isLoading || !isDirty} type="submit" appearance="primary">
              Entrar
            </Button>

            <Modal.Root>
              <Modal.Trigger>
                <Button type="button" appearance="tertiary">
                  Esqueci minha senha
                </Button>
              </Modal.Trigger>
              <Modal.Content>
                <ResetPassword />
              </Modal.Content>
            </Modal.Root>
          </div>
        </div>
      </form>
    </div>
  )
}

export default Form
